import { render, staticRenderFns } from "./fixedTable.vue?vue&type=template&id=5d03c874&scoped=true"
import script from "./fixedTable.vue?vue&type=script&lang=ts"
export * from "./fixedTable.vue?vue&type=script&lang=ts"
import style0 from "./index.less?vue&type=style&index=0&id=5d03c874&prod&lang=less&scoped=true&external"
import style1 from "./fixedTable.vue?vue&type=style&index=1&id=5d03c874&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d03c874",
  null
  
)

export default component.exports